import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { restaurantHighlightLegendItems } from './restaurant-highlight-config'
import { RestaurantLegendItem } from './restaurant-legend-item'

export const RestaurantHighlightLegend: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div css={legendListStyle}>
      {restaurantHighlightLegendItems.map(item => (
        <RestaurantLegendItem key={item.tone} tone={item.tone} label={t(item.labelKey)} />
      ))}
    </div>
  )
}

const legendListStyle = css({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: 16,
})
